<template>
  <v-sheet outlined :height="banner ? $config.page.bannerHeight: (collapseToolbar || inline ? null :  100)" color="transparent"
  :class="{'pt-5': largeScreen && !inline}">
    <v-app-bar       fixed flat 
      :shrink-on-scroll="banner ? true: false"
      :prominent="banner ? true: false"
      :src="banner"
      :fade-img-on-scroll="banner ? true: false"
      :hide-on-scroll="banner && largeScreen ? true: false"
      :height="banner ? $config.page.bannerHeight - ($slots.extension ? 92 : 0) : null"
      :style="'border: ' + (largeScreen ? '1px solid rgba(0,0,0,0.12)': '') + ';max-width:' + $config.page.width + 'px'" 
      :class="{'collapsed': collapseToolbar || showToolbar, 
      'inline' : inline,
      'extension' : $slots.extension ? true: false, 'clip-right' : clipRight,
      'mx-auto rounded-lg mt-5': largeScreen}" 
    >  <div class="hero" style="margin-left:-16px">
        <slot name="hero"><br></slot>
        </div>
      <template v-slot:img="{ props }" v-if="banner">
        
        <v-img
          v-bind="props"
         gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,.8)"
         class="text-center align-center"
        >
        
        </v-img>
        
      </template>
      <v-btn v-if="back" class="pl-2 app-btn" depressed fab small :to="back"><v-icon>arrow_back_ios</v-icon></v-btn>
      <v-app-bar-nav-icon v-else-if="!largeScreen" class="app-btn" depressed fab small @click="drawer=!drawer"></v-app-bar-nav-icon>
      <slot name="toolbar">
      
        <v-app-bar-title v-if="collapseToolbar && title" style="overflow:visible"><v-icon v-if="titleIcon && !showToolbar" dark class="mr-3">{{titleIcon}}</v-icon>{{title}}</v-app-bar-title>
        <v-app-bar-title v-else-if="(showToolbar || !banner) && toolbarTitle"><v-icon v-if="titleIcon && !showToolbar" dark class="mr-3" >{{titleIcon}}</v-icon>{{toolbarTitle}}</v-app-bar-title>
          <div @click="click" v-else
          class="header-title font-weight-light mb-2" style="white-space: nowrap;" :style="{'align-self': 'flex-end', 'margin-left': !isToolbar && banner && back ? '-30px':null, 'cursor': $listeners.click ? 'pointer' : null}" 
          :class="[!$vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-h4', !isToolbar && banner? 'white--text' : null]">
          <v-icon dark v-if="titleIcon && !showToolbar" class="mr-3">{{titleIcon}}</v-icon>{{title}}
          <v-icon v-if="$listeners.click" color="white">expand_more</v-icon>
          <v-subheader v-if="subtitle" dark class="pa-0 ma-0 text-no-wrap" v-html="subtitle" style="height:10px"></v-subheader>
          </div>
          
      </slot>

      <v-spacer></v-spacer>
      <slot name="actions"></slot>
       <v-icon v-if="icon" v-text="icon"></v-icon>
      <slot v-else name="icon"></slot>

      <template v-slot:extension v-if="$slots.extension">
        <slot name="extension"></slot>
      </template>
    </v-app-bar>
  </v-sheet>
</template>
    <script>
import headerItem from "@/modules/headerItem";
import { mapActions } from 'vuex'
export default {
  props: [ 'banner', 'title', 'noHeader', 'host', 'inline', 'clipRight' ,'toolbarTitle', 'subtitle', 'back','value','modal','fixed', 'color','icon', 'titleIcon','alignEnd','noGradient','collapseToolbar'],
   mixins: [headerItem],
  data: () => ({
    scrollTop: 0,
  }),

  computed: {
    drawer:{
            get(){
                return this.value
            },
            set(value){
                this.$emit('input', value)
            }
        },
    showToolbar(){
      return this.isToolbar || this.collapseToolbar
    },
    barColor(){
      if (this.color) return this.color
      return this.$store.state.config.dark ? 'primary' : 'white'
    }
  },
  async mounted(){
  },
   methods: {
      ...mapActions([
        'logout',
        'login'
      ]),
    click(){
      this.$emit('click')
    },
    handleLogout(){
      this.logout()
      this.$router.push('/')
    },
    
  },
};
</script>
    <style>
    .border-bottom .v-toolbar__extension,
    .border-bottom .v-toolbar__extension .v-toolbar__content{
      padding:0px!important;
    }
    
    .hero {
      position:absolute;
      width:100%;
      text-align:center;
      top:50px;
      z-index:200;
      -webkit-transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    transition: opacity 0.5s ease-in-out;
    }
    .v-app-bar--is-scrolled .hero{
        top:0px;
        opacity:0;
        z-index:-1;
    }
    .v-app-bar.inline{
      position:relative!important;
    }
    </style>